import React from 'react';
import { SectionHeading } from './SectionHeading';
import { costRows } from '../data/salesData';
export function CostSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-28" data-mp="9cg6mtqa4gvj">
      <div className="mx-auto max-w-4xl px-4" data-id="element-29" data-mp="4k6d73pygyoi">
        <SectionHeading eyebrow="⚖️ La cuenta que nadie hace" data-id="element-30" data-mp="4iv8n1oormwc">
          ¿Cuánto cuesta no tenerlo?
        </SectionHeading>

        <div className="sales-scrollbar mt-8 overflow-x-scroll pb-3" data-id="element-31" data-mp="3qsxszfzuomee">
          <table className="w-full min-w-[620px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--violet)]/40 text-left text-sm" data-id="element-32" data-mp="3qq3a3swhj9n3">
            <thead data-id="element-33" data-mp="3hs9q9hfwq8gt">
              <tr className="bg-[#16102e]" data-id="element-34" data-mp="3htu9iawru4zd">
                <th className="p-4 font-semibold text-white/45" data-id="element-35" data-mp="3ct6ms1fksaay">
                  Sin Sistema Keto
                </th>
                <th className="p-4 font-semibold text-[var(--lilac-light)]" data-id="element-36" data-mp="1fz20fe2o48go">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-37" data-mp="p7tfrwb1jwlc">
              {costRows.map((row, i) => <tr key={row.without} className={i % 2 === 0 ? 'bg-[#0d0819]' : 'bg-[#080510]'} data-id="element-38" data-mp="p9o4llpfo8up" data-mpi={i}>
                  <td className="border-t border-white/5 p-4 font-medium text-[var(--cream)]" data-id="element-39" data-mp="fa70h8pty30u">
                    {row.without}
                  </td>
                  <td className="border-t border-white/5 p-4 text-white/75" data-id="element-40" data-mp="kakzy2dd84n9">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-10 text-center font-display text-2xl font-bold text-[var(--lilac-light)] sm:text-3xl" data-id="element-41" data-mp="y89hb0884tnk">
          El próximo lunes puede ser diferente.
        </p>
      </div>
    </section>;
}